class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.gallerySlider = document.querySelector(".js-gallery-slider");
    this.productMediaCarousel = this.parentElement.querySelector(".js-product-media-carousel");
    this.modalTriggers = [...this.querySelectorAll(".js-product-media-trigger"), ...this.productMediaCarousel.querySelectorAll(".js-product-media-trigger")];
    
    if (this.modalTriggers.length && this.gallerySlider) {
      this.modalTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          const index = trigger.getAttribute("data-index");
          this.gallerySlider.scrollToSlide(index);
        });
      });
    }
  }
}

customElements.define("product-media", ProductMedia);

